import { css } from "@emotion/css";
import { withBasicStyles } from "@/styles/common";

export const useStyles = withBasicStyles(() => ({
  wrapper: css`
    padding: 0 16px;
    min-height: 300px;
    height: 100%;
    border-radius: 8px;
    display: flex;
    flex-direction: column;

    .x-markdown {
      --margin-ul-ol: 0 0 1em 1em;

      code {
        background: rgba(150, 150, 150, 0.2);
        border-radius: 3px;
      }

      .ant-highlightCode-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--ant-highlight-code-color-text-title);
        background: var(--ant-highlight-code-color-bg-title);
        padding: var(--ant-padding-sm);
        border-top-left-radius: var(--ant-border-radius);
        border-top-right-radius: var(--ant-border-radius);
      }
    }
  `,

  list: css`
    flex: 1;
    margin-top: 16px;
    overflow-y: auto;
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-scrollbar {
      display: none;
    }
    /* Firefox */
    scrollbar-width: none;
    /* IE 10+ */
    -ms-overflow-style: none;
  `,

  prologue: css`
    margin-bottom: 12px;
  `,

  suggestion: css`
    margin-bottom: 12px;
  `,

  suggestContent: css`
    display: inline-flex;
    border: 2px solid #e7e7e7;
    border-radius: 8px;
  `,

  userMsg: css`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 24px;
  `,

  userContainer: css`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  `,

  card: css`
    display: inline-block;
    padding: 12px 16px;
    background: #d5e3ff;
    border-radius: 12px;
    max-width: 100%;
    white-space: pre-line;
    word-break: break-all;
  `,

  botMsg: css`
    margin-bottom: 12px;
  `,

  emptyWrapper: css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    min-height: 200px;
  `,

  // 新增样式
  welcomeWrapper: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 20px;
    text-align: center;
  `,

  welcomeIcon: css`
    width: 64px;
    height: 64px;
    border-radius: 12px;
    margin-bottom: 16px;
  `,

  welcomeTitle: css`
    font-size: 24px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.88);
    margin-bottom: 8px;
  `,

  welcomeDesc: css`
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    margin-bottom: 24px;
  `,

  suggestionWrapper: css`
    margin-top: 16px;
  `,

  successBadge: css`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    background: #f6ffed;
    border: 1px solid #b7eb8f;
    border-radius: 4px;
    color: #52c41a;
    font-size: 13px;
    margin-bottom: 12px;
  `,

  fileSection: css`
    margin: 12px 0;
  `,

  fileHeader: css`
    font-size: 13px;
    color: rgba(0, 0, 0, 0.65);
    margin-bottom: 8px;
  `,

  metaFooter: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;
  `,

  actionIcons: css`
    color: rgba(0, 0, 0, 0.45);

    & > span {
      cursor: pointer;
      transition: color 0.2s;

      &:hover {
        color: #1890ff;
      }
    }
  `,

  fnCall: css`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 11px;
    border-radius: 24px;
    line-height: 16px;
    border: 1px solid #e7e7e7;
    cursor: pointer;
  `,

  confirm: css`
    padding: 12px;
    border-radius: 12px;
    border: 1px solid #e7e7e7;
  `,

  footer: css`
    /* senderWrap and tip moved to top-level keys so they are
       accessible as styles.senderWrap and styles.tip in the component */
  `,

  sender: css`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 8px 8px 12px;
    border: 1px solid #e7e7e7;
    border-radius: 24px;

    /* .input moved to top-level key so component can use styles.input */
  `,

  senderWrap: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  `,

  tip: css`
    padding: 4px;
    font-size: 12px;
    text-align: center;
    color: rgba(0, 0, 0, 0.4);
  `,

  input: css`
    padding: 0;
    margin: 5px 0;
    line-height: 22px;
    font-size: 15px;
    border-radius: 0;
    border: none;

    &:focus {
      box-shadow: none;
    }
  `,
}));

export default useStyles;
